// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.amex-offer {
  position: relative;
  display: flex;
  flex-direction: column;
  background: #282828;
  color: #ffffff;
  padding: 0 20px 24px;
}
.amex-offer .close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 22px;
  height: 22px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
}
.amex-offer .close-btn ion-icon {
  font-size: 22px;
}
.amex-offer .title {
  position: relative;
  margin: 60px 0 0;
  padding-bottom: 11px;
  font-family: AppFontEintrachtOFC;
  font-size: 24px;
  line-height: 110%;
  text-transform: uppercase;
  color: #ffffff;
}
.amex-offer .title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 220px;
  height: 3px;
  background: var(--ion-color-eintracht-red);
}
.amex-offer .text {
  margin: 20px 0 0;
  font-family: AppFontEintrachtOFCSans;
  font-size: 16px;
  line-height: 130%;
  color: #ffffff;
}
.amex-offer .terms {
  margin-top: 28px;
}
.amex-offer .link {
  margin-top: 6px;
  font-family: AppFontEintrachtSansOFCBold;
  color: #ffffff;
  text-decoration: underline;
  text-underline-offset: 2px;
  word-break: break-all;
}
.amex-offer .confirm-btn {
  --background: var(--ion-color-eintracht-red);
  --border-radius: 6px;
  --box-shadow: none;
  --border-width: 0;
  border: none;
  width: 100%;
  height: 50px;
  min-height: 50px;
  margin: 19px 0 0;
  padding: 0;
  font-size: 16px;
  line-height: 130%;
  text-transform: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/amex-offer-modal/amex-offer-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;AACF;AACE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;AACJ;AACI;EACE,eAAA;AACN;AAGE;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;AADJ;AAGI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,0CAAA;AADN;AAKE;EACE,gBAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAHJ;AAME;EACE,gBAAA;AAJJ;AAOE;EACE,eAAA;EACA,wCAAA;EACA,cAAA;EACA,0BAAA;EACA,0BAAA;EACA,qBAAA;AALJ;AAQE;EACE,4CAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AANJ","sourcesContent":[".amex-offer {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  background: #282828;\n  color: #ffffff;\n  padding: 0 20px 24px;\n\n  .close-btn {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    width: 22px;\n    height: 22px;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n\n    ion-icon {\n      font-size: 22px;\n    }\n  }\n\n  .title {\n    position: relative;\n    margin: 60px 0 0;\n    padding-bottom: 11px;\n    font-family: AppFontEintrachtOFC;\n    font-size: 24px;\n    line-height: 110%;\n    text-transform: uppercase;\n    color: #ffffff;\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      width: 220px;\n      height: 3px;\n      background: var(--ion-color-eintracht-red);\n    }\n  }\n\n  .text {\n    margin: 20px 0 0;\n    font-family: AppFontEintrachtOFCSans;\n    font-size: 16px;\n    line-height: 130%;\n    color: #ffffff;\n  }\n\n  .terms {\n    margin-top: 28px;\n  }\n\n  .link {\n    margin-top: 6px;\n    font-family: AppFontEintrachtSansOFCBold;\n    color: #ffffff;\n    text-decoration: underline;\n    text-underline-offset: 2px;\n    word-break: break-all;\n  }\n\n  .confirm-btn {\n    --background: var(--ion-color-eintracht-red);\n    --border-radius: 6px;\n    --box-shadow: none;\n    --border-width: 0;\n    border: none;\n    width: 100%;\n    height: 50px;\n    min-height: 50px;\n    margin: 19px 0 0;\n    padding: 0;\n    font-size: 16px;\n    line-height: 130%;\n    text-transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
